//
// ExportNumberFormat.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ExportNumberFormat = {
    FORMATTED:0,
    RAW:1
};
export default ExportNumberFormat;
